module.exports = __webpack_public_path__ + "img/undraw_teacher.12c36c06.svg";